import { useSelector } from "react-redux";
import { useLocation, matchPath } from "react-router-dom";
import { routes } from "../../../routes";
import { breadcrumbResolvers } from "./breadcrumbResolvers";
import { useBreadcrumbs } from "../../../hooks/useBreadcrumbs";
import { HeaderContainer } from "./headerContainer";
import { selectBreadcrumbState } from "./selectBreadcrumbState";

export const Header = (props) => {
  const location = useLocation();
  const breadcrumbState = useSelector(selectBreadcrumbState);

  const context = {};

  routes.forEach((route) => {
    if (!route.breadcrumbResolver) return;

    const match = matchPath(
      { path: route.path, end: false },
      location.pathname
    );

    if (!match) return;

    const resolver = breadcrumbResolvers[route.breadcrumbResolver];
    if (resolver) {
      context[route.breadcrumbResolver] = resolver(breadcrumbState, match.params);
    }
  });

  const breadcrumbs = useBreadcrumbs(context);

  const last = breadcrumbs[breadcrumbs.length - 1];
  const visibleBreadcrumbs = breadcrumbs.filter((bc) => !(bc.hideWhenExact && bc.isExact));

  const showBreadcrumb = last && !(last.hideWhenExact && last.isExact) && visibleBreadcrumbs.length > 1;

  if (props?.hideHeader) {
    return null;
  }

  return (
    <HeaderContainer
      {...props}
      breadcrumbs={{
        show: showBreadcrumb,
        items: visibleBreadcrumbs,
      }}
    />
  );
};